
  export const initialInvoice = {
    clientName: "",
    clientCode: "",
    clientAddress: "",
    clientContactPerson: "",
    clientContact: "",
    clientType: "",
    clientEmail: "",
    closeCard: false,
    billTo: "Bill To:",
    currency: "INR",
    subject: "",
    invoiceTitleLabel: "Invoice#",
    invoiceTitle: "",
    invoiceDateLabel: "Invoice Date",
    invoiceDate: "",
    invoiceDueDateLabel: "Due Date",
    invoiceDueDate: "",
    subtotal: "",
    taxes: "",
    discount: "",
    salesPerson: "",
    salesPersonId: "",
    productLineDescription: "Item Description",
    productLineQuantity: "Quantity",
    productLineUnits: "Units",
    productLineQuantityRate: "Rate",
    productLineQuantityAmount: "Amount",
    productLineDiscount: "Discount(%)",
    productLineTax: "Tax",
    productLines: [],
    subTotalLabel: "Sub Total",
    Total: "",
    TotalInWords: "",
    adjustmentLabel: "Adjustments",
    adjustmentvalue: "0",
    taxLabel: "Sale Tax (10%)",
    totalLabel: "TOTAL",
    notesLabel: "Customer Notes",
    notes: "It was great doing business with you.",
    termLabel: "Terms & Conditions",
    termsandconditions:[
      {
        type: "bulleted-list",
        children: [
          { text: "Delivery :", bold: true },
          {
            text: " Standard delivery time is 6-8 Weeks from PO , Advance & Drawing Approval along with MFG Clearance.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Freight :", bold: true },
          {
            text: " Our Rates are Ex-Works , Ghaziabad . Freight shall be charged Extra from Ghaziabad as actual.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Packaging :", bold: true },
          {
            text: " Standard Packaging is Included. If Wooden Packaging or Export Worthy Packaging is required it shall be charged extra. Kindly take Quote for same separately if required.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Offer Validity :", bold: true },
          {
            text: " Our offer is valid only for 21 Days from Offer Date.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Scope :", bold: true },
          {
            text: " Our scope is Supply Only. If E-T-C or Supervision During Commissioning is required , it shall be charged extra.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Payment Terms :", bold: true },
          {
            text: " 40% Advance along with PO , and Balance along with all Taxes and Duties Against Proforma Invoice before Dispatch",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Warranty :", bold: true },
          {
            text: " The warranty period will be 12 months from the date of dispatch. The Purchaser owns responsibility of proper handling, safety storage of the equipment’s . Any defect due to improper handling or unsafe storage is not being covered under offered warranty. Any rectification/repair in the warranty period do not include/consider personnel costs for rectification/repair services. The manpower charges (i. e. To & Fro Air tickets, Accommodation, food & conveyance) as applicable are to be borne by Purchaser only.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Jurisdiction :", bold: true },
          {
            text: " All disputes will be subject to GHAZIABAD jurisdiction.",
          },
        ],
      },
    ],
  };
  

  export const assertinitialInvoice = {
    termsandconditions: [
      {
        type: "bulleted-list",
        children: [
          { text: "Nature of Business :", bold: true },
          {
            text: "We (Business Partner) agree to design, develop and deliver Ecommerce website(roshaliving.com) for Mr. Manul (client)",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Scope of Work :", bold: true },
          {
            text: "Refer sow.pdf",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Compensation :", bold: true },
          {
            text: "Refer Annexure B.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Commencement Date :", bold: true },
          {
            text: "01st June 2022.",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Estimated Time of Development: ", bold: true },
          {
            text: "Estimated Time of Development:",
          },
        ],
      },
      // Section 6 - Payment Terms and Conditions
      {
        type: "bulleted-list",
        children: [
          { text: "Payment Terms and Conditions:", bold: true },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Terms and conditions:", bold: true },
          {
            text: "25% advance, 25% after completion of the work, Balance at the time of delivery",
          },
        ],
      },
      {
        type: "bulleted-list",
        children: [
          { text: "Payment Details:", bold: true },
          {
            text: "Company Name: Assert IT Solutions LLP, Bank Name: Axis Bank, Account Number: 917020049079576, IFSC Code: UTIB0001082, Branch: Raj Nagar, Ghaziabad (UP), GSTIN: 09ABHFA5832E1ZJ",
          },
        ],
      },
      // Section 7 - Term/Termination
      {
        type: "bulleted-list",
        children: [
          { text: "Term/Termination:", bold: true },
          {
            text: "The term of this Job Contract shall be for a period of one year initially. Based on the performance, the contract can be renewed on the revised terms and conditions as agreed upon by the two parties.",
          },
        ],
      },
      // Section 8 - Disputes
      {
        type: "bulleted-list",
        children: [
          { text: "Disputes:", bold: true },
          {
            text: "This Job contract shall be governed by the laws. Any disputes arising between the partners because of this contract shall be settled by arbitration in accordance with the rules of the Arbitration Association and judgment upon the award rendered may be entered in any court in Ghaziabad, Uttar Pradesh jurisdiction thereof.",
          },
        ],
      },
      // Section 9 - Confidentiality
      {
        type: "bulleted-list",
        children: [
          { text: "Confidentiality:", bold: true },
          {
            text: "The Business Partner shall hold in strict confidence and not use, except for the benefit of Client, or disclose to any individual or entity any Confidential Information. Confidential Information means any and all information and knowledge regarding Client which Business Partner assimilates during Project engagement with Client.",
          },
        ],
      },
      // Section 10 - Ownership of Prepared Materials
      {
        type: "bulleted-list",
        children: [
          { text: "Ownership of Prepared Materials:", bold: true },
          {
            text: "All original works of authorship made by the Client during the Term within the scope of the Business Partner's engagement by the Client are irrevocably owned by the Client.",
          },
        ],
      },
      // Section 11 - Responsibility
      {
        type: "bulleted-list",
        children: [
          { text: "Responsibility:", bold: true },
          {
            text: "The Business Partner will work as per project Job Contract and client requirements, providing customer support and resolving critical issues as needed.",
          },
        ],
      },
      // Section 12 - Termination
      {
        type: "bulleted-list",
        children: [
          { text: "Termination:", bold: true },
          {
            text: "This Job Contract may be terminated if either party materially breaches any obligation. Notice of termination must be submitted in writing within ten (10) days and sent by official email.",
          },
        ],
      },
      // Section 13 - Entire Job Contract
      {
        type: "bulleted-list",
        children: [
          { text: "Entire Job Contract:", bold: true },
          {
            text: "The Job Contract sets forth the understanding between Client and Business Partner and merges all prior discussions. No modification will be effective unless in writing signed by both parties.",
          },
        ],
      },
    ],
  };


  export const  jobRolesDescription = {
    "ios developer": "Mobile application development, API integration, UI/UX implementation, App Store deployment",
    "costing engineer": "Handling of Costing work of orders and inquiries and coordination with all departments regarding production of panels.",
    "it head": "Managing of all IT Infrastructure of our officies: Networking,CCTV,Mobiles,Internet,Printers,Firewall,Digital Infrastructure ,ERP System etc.\n Handling all activities related to all IT Inftastructure.",
    "sales": "Handling of Coordinations of sales work of orders and inquiries and coordination with all department sales work.",
    "accounts": "Financial record keeping, reporting, auditing, tax computation, budgeting, financial analysis, decision making, and compliance management.",
    "export": "Documentation management, Logistics coordination, Customer communication, Compliance management, Cost management, Vendor management, Export order processing, Reporting and analysis",
    "social media": "Content creation and curation, Audience engagement, Social media platform management, Analytics and reporting, Trend analysis, Campaign development and execution, Brand consistency.",
    "Production": "Production Planning and Scheduling,Resource Allocation,Quality Control,Cost Management,Team Leadership,Problem Solving,Safety Compliance,Reporting and Analysis,Continuous Improvement,CrossFunctional Collaboration",
    "Designing": "Focus on Design of CONTROL PANELS, ELECTRICAL CONTROL PANELS, AUTOMATION CONTROL PANELS etc Solution conceptualization,Drawing preparation,BoM - Auto Cad electrical/mechanical.",
    "Quality Head": "Strategy Development,Quality Assurance Oversight,Team Leadership,Compliance Management,Continuous Improvement,Collaboration",
    "CNC Operator": "Machine setup,Programming,Operation monitoring, Qualitycontrol, Troubleshooting, Maintenance, Documentation Safety compliance.",
    "Bending Machine Operator": "Machine setup,Operating the machine,Quality control,Technical skills,Maintenance and troubleshooting.",
    "Fabrication Designer": "Design and modeling,Technical analysis,Material selection, Blueprint creation,Collaboration,Prototyping,Problem-solving, Proficient in CAD oftware,Technical drawing skills,Problem-solving abilities,Analytical skills",
    "Admin": "Scheduling,Communication,Records,Policies,Inventory,Inquiries,Visitors,Organizational skills,Computer literacy, Time management,Communication,Critical thinking,Attention to detail",
    "Purchase": "Strategic Sourcing,Contract Negotiation,Supplier Relationship Management, Cost Optimization,Procurement Planning,Quality Control,Risk Management, Team Leadership,Compliance Management,Communication and Collaboration."
  };
  